import { createAction } from "@reduxjs/toolkit";
import { IUser } from "@qwealth/qdata";

const SET_AUTH_USER = 'SET_AUTH_USER';
export const setAuthUser = createAction<IUser>(SET_AUTH_USER);

const SET_AUTH_USER_HOUSEHOLD = 'SET_AUTH_USER_HOUSEHOLD';
export const setUserHouseholdId = createAction<string>(SET_AUTH_USER_HOUSEHOLD);
